/**
 * Controls `<IdbMigration>` gate visibility. Set on Migrate-success or on
 * Skip; cleared by Settings → Migrate IDB to drive the user back into the
 * gate.
 */
export const IDB_MIGRATION_DISMISSED_KEY = "idb_migration_dismissed";

/**
 * Controls Settings → Migrate IDB button visibility. Set when a migration run
 * succeeds end-to-end OR when the gate found nothing to migrate. Means
 * "this browser has no pending IDB→DB work."
 */
export const IDB_MIGRATION_COMPLETED_KEY = "idb_migration_completed";
